<div [formGroup]="form">
    <div [ngSwitch]="field.controlType">
        <div *ngSwitchCase="'textbox'">
            <mat-form-field appearance="outline">
                <mat-label>{{ field.label | translate }}</mat-label>
                <input matInput [id]="field.key" [formControlName]="field.key" [type]="field.type" [readonly]="!userRole.includes('admin')" />
            </mat-form-field> 
        </div>
    </div>
    <div class="errorMessage" *ngIf="!isValid">{{field.label}} is required</div>
  </div>
  
  